import type { TooltipProps } from 'antd'
import { Tooltip as AntdTooltip } from 'antd'

export default function Tooltip({ ...props }: TooltipProps) {
  return <AntdTooltip {...props} />
}
